import { render, staticRenderFns } from "./PainelComiteGovernancaBolsasEtc.vue?vue&type=template&id=04e87077"
import script from "./PainelComiteGovernancaBolsasEtc.vue?vue&type=script&lang=js"
export * from "./PainelComiteGovernancaBolsasEtc.vue?vue&type=script&lang=js"
import style0 from "./PainelComiteGovernancaBolsasEtc.vue?vue&type=style&index=0&id=04e87077&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports